
import { router } from "../utils/APIUrls";
import axiosConnectorInstance from "./AxioConnector"

export const loginUser = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.login, requestPayload, {

        })
        console.log("sign up api response", response);
        return response?.data
    } catch (error: any) {
        console.log('errorerrorerror', error)
        return error?.response?.data
    }
}

export const editProfile = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.editUser, requestPayload, {

        })
        console.log("edit profile api response", response);
        return response?.data
    } catch (error: any) {
        console.log('edit profile errorerrorerror', error)
        return error?.response?.data
    }
}

export const forgotPwd = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.forgotPwd, requestPayload, {

        })
        console.log("forgot password api response", response);
        return response?.data
    } catch (error: any) {
        console.log('forgot password errorerrorerror', error)
        return error?.response?.data
    }
}

export const verifyOTP = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.verifyOTP, requestPayload, {

        })
        console.log("verify otp api response", response);
        return response?.data
    } catch (error: any) {
        console.log('verify otp errorerrorerror', error)
        return error?.response?.data
    }
}

export const resetPwd = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.resetPwd, requestPayload, {

        })
        console.log("reset password api response", response);
        return response?.data
    } catch (error: any) {
        console.log('reset password errorerrorerror', error)
        return error?.response?.data
    }
}

export const registerUser = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.register, requestPayload, {

        })
        console.log("registerapi response", response);
        return response?.data
    } catch (error: any) {
        console.log('errorerrorerror', error)
        return error?.response?.data
    }
}

export const deleteAccount = async () => {
    try {
        const response = await axiosConnectorInstance.get(router?.deleteAccount, {

        })
        console.log("delete account api response", response);
        return response?.data
    } catch (error: any) {
        console.log('errorerrorerror', error)
        return error?.response?.data
    }
}

export const searchSpace = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.searchSpace, requestPayload, {

        })
        console.log("search space api response", response);
        return response?.data
    } catch (error: any) {
        console.log('search space api error', error)
        return error?.response?.data
    }
}

export const paymentToggle = async () => {
    try {
        const response = await axiosConnectorInstance.get(router?.paymentToggle)
        console.log("is payment api response", response);
        return response?.data
    } catch (error: any) {
        console.log('is payment api error', error)
        return error?.response?.data
    }
}

export const payment = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.payment, requestPayload)
        console.log("payment api response", response);
        return response?.data
    } catch (error: any) {
        console.log('payment api error', error)
        return error?.response?.data
    }
}

export const confirmPayment = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.confirmPayment, requestPayload)
        console.log("payment api response", response);
        return response?.data
    } catch (error: any) {
        console.log('payment api error', error)
        return error?.response?.data
    }
}

export const addSpace = async (requestPayload: any) => {
    console.log("requestPayload", requestPayload);

    try {
        const response = await axiosConnectorInstance.post(router?.createSpace, requestPayload)
        console.log("add space api response", response);
        return response?.data
    } catch (error: any) {
        console.log('add space api error', error)
        return error?.response?.data
    }
}

export const viewSpaceList = async () => {
    try {
        const response = await axiosConnectorInstance.get(router?.viewSpaceList)
        console.log("view space api response", response);
        return response?.data
    } catch (error: any) {
        console.log('view space api error', error)
        return error?.response?.data
    }
}

export const viewSpaceDetails = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.get(`${router?.viewSpaceDetails}/${requestPayload}`)
        console.log("view space details api response", response);
        return response?.data
    } catch (error: any) {
        console.log('view space details api error', error)
        return error?.response?.data
    }
}

export const deleteSpace = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.deleteSpace, requestPayload)
        console.log("delete space details api response", response);
        return response?.data
    } catch (error: any) {
        console.log('delete space details api error', error)
        return error?.response?.data
    }
}

export const getPropertyCount = async () => {
    try {
        const response = await axiosConnectorInstance.get(router?.getPropertyCount, {
        })
        console.log("get property count api response", response);
        return response?.data
    } catch (error: any) {
        console.log('get property count error', error)
        return error?.response?.data
    }
}

export const getSpaceByCountry = async () => {
    try {
        const response = await axiosConnectorInstance.get(router?.getSpaceByCountry, {
        })
        console.log("get space by country api response", response);
        return response?.data
    } catch (error: any) {
        console.log('get space by country error', error)
        return error?.response?.data
    }
}

export const contactUs = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.contactUs, requestPayload)
        console.log("contact us api response", response);
        return response?.data
    } catch (error: any) {
        console.log('contact us error', error)
        return error?.response?.data
    }
}

export const sendMsg = async (requestPayload: any) => {
    try {
        const response = await axiosConnectorInstance.post(router?.sendMessage, requestPayload)
        console.log("send msg api response", response);
        return response?.data
    } catch (error: any) {
        console.log('send msg error', error)
        return error?.response?.data
    }
}